// extracted by mini-css-extract-plugin
export var brand = "_r-9";
export var button = "_r-0";
export var chevron = "_r-v";
export var chevronButton = "_r-w";
export var content = "_r-n";
export var danger = "_r-g";
export var dangerOutlined = "_r-h";
export var dark = "_r-l";
export var darkTheme = "_r-c";
export var extraSmall = "_r-4";
export var fullWidth = "_r-8";
export var ghost = "_r-d";
export var gray = "_r-t";
export var icon = "_r-p";
export var iconButton = "_r-s";
export var iconButtonBorder = "_r-x";
export var iconButtonBorderDark = "_r-y";
export var iconButtonBorderLight = "_r-z";
export var iconLeft = "_r-q";
export var iconRight = "_r-r";
export var large = "_r-1";
export var light = "_r-m";
export var medium = "_r-2";
export var micro = "_r-5";
export var nano = "_r-7";
export var outlined = "_r-k";
export var pending = "_r-a";
export var primary = "_r-i";
export var shadow = "_r-o";
export var small = "_r-3";
export var solidLight = "_r-e";
export var solidLightBrand = "_r-f";
export var spinner = "_r-u";
export var transparent = "_r-j";
export var warning = "_r-b";
export var wideNano = "_r-6";